<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pm6z24/tc-custom/9780300241020.jpg?1708747595029" alt="This image is the cover for the book Emperor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Emperor
      </h1>
      <p class="bookDescription body article font2">
        <b>This “elegant and engaging” biography dramatically reinterprets the life and reign of the sixteenth-century Holy Roman Emperor: “a masterpiece” (Susannah Lipscomb, <i>Financial Times</i>).</b><br/><br/>The life of Emperor Charles V (1500–1558), ruler of Spain, Germany, the Netherlands, and much of Italy and Central and South America, has long intrigued biographers. But capturing the nature of this elusive man has proven notoriously difficult—especially given his relentless travel, tight control of his own image, and the complexity of governing the world’s first transatlantic empire.<br/><br/>Geoffrey Parker, one of the world’s leading historians of early modern Europe, has examined the surviving written sources in Dutch, French, German, Italian, Latin, and Spanish, as well as visual and material evidence. In <i>Emperor</i>, he explores the crucial decisions that created and preserved this vast empire, analyzes Charles’s achievements within the context of both personal and structural factors, and scrutinizes the intimate details of the ruler’s life for clues to his character and inclinations. The result is a unique biography that interrogates every dimension of Charles’s reign and views the world through the emperor’s own eyes.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Geoffrey Parker
      </h2>
      
      <p class="authorDescription body article"><B>Geoffrey Parker </B> teaches history at The Ohio State University. He has published forty books, including <I>Global Crisis</I> and <I>Imprudent King</I> for Yale University Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d3d0e1e